import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { authHeader, formsFetch, retryServerErrors, unwrap } from "../lib/formsApi";
import { asLocale } from "../lib/i18n/locales";

import useToken from "./useToken";

const assessmentKey = (id: string) => ["assessment", id];

export const useAssessmentDetail = (id: string) => {
    const { token } = useToken();
    const { locale } = useIntl();
    return useQuery({
        queryKey: [...assessmentKey(id), locale],
        queryFn: async ({ signal }) =>
            unwrap(
                await formsFetch.GET("/api/ast/{id}", {
                    params: { path: { id }, query: { lang: asLocale(locale) } },
                    headers: authHeader(token),
                    signal,
                }),
                "get assessment"
            ),
        placeholderData: (previous) => previous,
        refetchInterval: 600_000,
        retry: retryServerErrors,
    });
};

export const useRefetchAssessment = () => {
    const queryClient = useQueryClient();
    const { id } = useParams<{ id: string }>();
    return useCallback(() => queryClient.invalidateQueries({ queryKey: assessmentKey(id ?? "") }), [queryClient, id]);
};
